import React, { useContext } from "react";
import * as headerConfig from "./header.config";

//
import "../header/header.component.scss";
import Button from "components/button/button.component";
import assetPath from "utils/assetPath.utils";
import root from "utils/root.utils";
import { Link } from "react-router-dom";
import ShellContext from "shell/shell.context";
import { isPropertySignature } from "typescript";

interface Props {}

const Header: React.FC<Props> = () => {
  const headerData = headerConfig.header.data;
  const context = useContext(ShellContext);
  return (
    <div className="header">
      <div className="header__wrapper">
        <div className="header__inner">
          {/* LOGO */}
          <Link className="header-logo" to="/">
            <img
              src={assetPath(headerData.logo.desktop)}
              alt=""
              className="is-desktop"
            />
            <img
              src={assetPath(headerData.logo.mobile)}
              alt=""
              className="is-mobile"
            />
          </Link>
          <div className="header-right">
            {/* SOCIAL MEDIA */}
            <div className="header-right-icons">
              <ul className="header-right-icons__list">
                {headerData.icons.map((item, key) => (
                  <li key={key} className="header-right-icons__item ">
                    <a
                      href={item.link}
                      key={key}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={assetPath(item.image)} alt="" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            {/* BUTTON */}
            {headerData.buttons.map((item, key) => {
              if (!item.phase.includes(context.phase)) {
                return null;
              }
              return <Button {...item} key={key} className="header-button" disabled={!!item.disabled} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
